import { BASE_AUTHORIZATION } from 'constants/env'

export const authorization: string = `Basic ${Buffer.from(
  BASE_AUTHORIZATION,
).toString('base64')}`
